<template>
  <div class="box text-center">
    <!-- /.box-header -->
    <div class="box-body">
      <div class="col-xs-12">
        <div class="inline-block pull-left text-left">
          <h4>
            訂購與否或顯示隱藏
          </h4>
          <h5><span class="text-red">＊</span> "不加入" 為新增菜單時，將勾選的項目排除。</h5>
        </div>
      </div>
      <div class="col-xs-12 p-10">
        <h5 class="text-left">
          <br />
          1.&nbsp;&nbsp;商品分類與商品與各商品組合
        </h5>
        <div class="grid" style="width: 100%;">
          <div class="col-xs-12 col-lg-4 grid-item p-5" v-for="(c, index) in category" :key="index">
            <div class="col-xs-12 card">
              <div class="col-xs-12 text-left m-t-10">
                &nbsp;
                <label class="bg-green label label-text-60-p cursor-pointer" @click="changeCategoryAdd(c, false)">全選</label>&nbsp;
                <label class="bg-red label label-text-60-p cursor-pointer" @click="changeCategoryAdd(c, true)">全取消</label>
                &nbsp;
              </div>
              <div class="col-xs-12 m-b-5 text-left p-x-15">
                <div class="text-right inline-block block-checkbox text-15" style="margin-right: 10px;">
                  <span class="text-dark-gray text-13">不加入</span>
                </div>
              </div>
              <div class="col-xs-12 card-title text-left p-x-15">
                <span class="pull-left">{{c.name}} <small>{{c.remark}}</small></span>
                <div class="text-right inline-block m-r-15 block-checkbox">
                  <span class="checkbox-addmenu">
                    <input type="checkbox" v-model="c.is_remove" :id="'c-' + c.category_id + '-is-add'" class="css-checkbox" @input="changeCategoryAdd(c)">
                    <label :for="'c-' + c.category_id + '-is-add'" class="css-label css-label-add"></label>
                  </span>
                </div>
              </div>
              <div class="col-xs-12 text-left">
                <ul class="nav p-x-15">
                  <li class="card-product" v-for="(p, index) in c.product_list" :key="index">
                    <div class="">
                      {{p.name}} <small>{{p.remark}}</small>
                      <div class="text-right inline-block block-checkbox">
                        <span class="checkbox-addmenu">
                          <input type="checkbox" v-model="p.is_remove" :id="'p-' + p.product_id + '-is-add'" class="css-checkbox"  @input="changeProductAdd(c, p)">
                          <label :for="'p-' + p.product_id + '-is-add'" class="css-label css-label-add"></label>
                        </span>
                      </div>
                      <div class="" v-for="(combine, index) in p.combine_list" :key="index">
                        <span class="text-15" :class="{'combine-gray': combine.is_remove}">
                          <i class="fa fa-caret-right" aria-hidden="true"></i>&nbsp;&nbsp;{{combine.name}} <small>{{combine.remark}}</small>
                        </span>
                        <div class="text-right inline-block block-checkbox">
                          <span class="checkbox-addmenu">
                            <input type="checkbox" v-model="combine.is_remove" :id="'com-' + combine.combine_id + '-is-add'" class="css-checkbox"  @input="changeCombineAdd(c, p, combine)">
                            <label :for="'com-' + combine.combine_id + '-is-add'" class="css-label css-label-add"></label>
                          </span>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li class="card-product" v-for="(pa, index) in c.package_list" :key="index">
                    <div class="">
                      {{pa.name}} <small>{{pa.remark}}</small>
                      <div class="text-right inline-block block-checkbox">
                        <span class="checkbox-addmenu">
                          <input type="checkbox" v-model="pa.is_remove" :id="pa.package_id + '-is-add'" class="css-checkbox" @input="changeProductAdd(c, pa)">
                          <label :for="pa.package_id + '-is-add'" class="css-label css-label-add"></label>
                        </span>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-lg-4 grid-item p-5" v-for="(o, index) in accessory" :key="index">
            <div class="col-xs-12 card">
              <div class="col-xs-12 m-b-5 text-left p-x-15 m-t-10">
                <div class="text-right inline-block block-checkbox text-15" style="margin-right: 10px;">
                  <span class="text-dark-gray text-13">不加入</span>
                </div>
              </div>
              <div class="col-xs-12 card-title text-left p-x-15">
                <span class="pull-left">{{o.name}} <small>{{o.remark}}</small></span>
                <div class="text-right inline-block m-r-15 block-checkbox">
                </div>
              </div>
              <div class="col-xs-12 text-left">
                <ul class="nav p-x-15">
                  <li class="card-product" v-for="(p, index) in o.product_list" :key="index">
                    <div class="">
                      {{p.name}} <small>{{p.remark}}</small>
                      <div class="text-right inline-block block-checkbox">
                        <span class="checkbox-addmenu">
                          <input type="checkbox" v-model="p.is_remove" :id="p.product_id + '-is-add'" class="css-checkbox"  @input="changeProductAdd(o, p)">
                          <label :for="p.product_id + '-is-add'" class="css-label css-label-add"></label>
                        </span>
                      </div>
                      <div class="" v-for="(combine, index) in p.combine_list" :key="index">
                        <span class="text-15 text-light-gray">
                          <i class="fa fa-caret-right" aria-hidden="true"></i>&nbsp;&nbsp;{{combine.name}} <small>{{combine.remark}}</small>
                        </span>
                        <div class="text-right inline-block block-checkbox">
                          <span class="checkbox-addmenu">
                            <input type="checkbox" v-model="combine.is_remove" :id="combine.combine_id + '-is-add'" class="css-checkbox" @input="changeProductAdd(o, p, combine)">
                            <label :for="combine.combine_id + '-is-add'" class="css-label css-label-add"></label>
                          </span>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="box-footer text-center">
      <button class="btn btn-success" @click="gotoFrom">
        上一步
      </button>
      <button class="btn btn-success" @click="gotoNext">
        完成菜單
      </button>
    </div>
    <br />
  </div>
</template>

<script>
import $ from 'jquery'
import Masonry from 'masonry-layout'
import CombineModal from './CombineModal.vue'
import { mapGetters } from 'vuex'
import NdExtendHandleMenu from '@/extends/nd-extend-handle-menu.vue'

export default {
  name: 'CrJoinMenuTemp',
  extends: NdExtendHandleMenu,
  components: {
    'combine-modal': CombineModal
  },
  props: {
    'info': {
      type: Object
    }
  },
  data () {
    return {
      menuId: this.$route.params.menu_id,
      brandId: this.$route.params.brand_id,
      current: {
        productName: '',
        productId: 0
      },
      count: 20,
      brandName: '',
      brandType: '',
      amount: {
        adjust: 1,
        option: 1,
        product: 1,
        category: 1,
        resource: 1,
        others: 1
      },
      adjustNumList: [],
      adjust: [],
      option: [],
      cateNumList: [],
      category: [],
      product: [],
      prodNumList: {},
      all: {
        category: [],
        product: [],
        adjust: [],
        option: [],
        combination: []
      },
      menuInfo: {},
      menuList: '',
      created: false,
      getTimes: 0,
      time: 0,
      accessory: []
    }
  },
  methods: {
    init () {
      this.getMenuResource()
    },
    isActive (index) {
      if (index === 1) return true
      else return false
    },
    showMenu () {
      if ($('.grid') && $('.grid-item')) {
        var m = new Masonry('.grid', {
          itemSelector: '.grid-item',
          columnWidth: '.grid-item'
        })
        m.reloadItems()
        m.layout()
      }
    },
    getProduct (index) {
      return this.product[index]
    },
    openCombineModal (name, index) {
      this.current.productId = index
      this.current.productName = name
    },
    gotoFrom () {
      let name = ''
      let params = {
        brand_id: this.$route.params.brand_id,
        store_id: ''
      }
      let query = {
        copy_menu_id: this.$route.query.copy_menu_id
      }

      if (this.menuId && this.isStore) {
        // '門市菜單 / 編輯菜單'
        name = 'StoreMenuEdite'
        params.store_id = this.$route.params.store_id
      } else if (this.menuId) {
        // '編輯菜單'
        name = 'upMenu'
      } else if (!this.menuId && this.isStore) {
        // '門市菜單 / 菜單建置 / 新增菜單'
        name = 'StoreMenuOptionCreateView'
      } else if (!this.menuId) {
        // 新增菜單
        name = 'crOption'
      }

      this.$router.push({ name, params, query })
    },
    gotoNext () {
      this.joinMenu()
    },
    getMenuResource (index) {
      if (index) this.amount.resource = index
      const url = this.base + this.id + '/menu/resource?page=' + this.amount.resource + '&size=' + this.count
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          response.data.resource_list.forEach((category) => {
            this.$set(category, 'is_enable', this.created)
            this.$set(category, 'is_visible', this.created)
            this.$set(category, 'is_remove', this.created)
            category.package_list.forEach((pack) => {
              this.$set(pack, 'is_enable', this.created)
              this.$set(pack, 'is_visible', this.created)
              this.$set(pack, 'is_remove', this.created)
            })
            category.product_list.forEach((product) => {
              this.$set(product, 'is_enable', this.created)
              this.$set(product, 'is_visible', this.created)
              this.$set(product, 'is_remove', this.created)
              product.combine_list.forEach((combine) => {
                this.$set(combine, 'is_enable', this.created)
                this.$set(combine, 'is_visible', this.created)
                this.$set(combine, 'is_remove', this.created)
              })
            })
            this.category.push(category)
          })
          if (response.data.resource_list.length) {
            const i = this.amount.resource + 1
            this.getMenuResource(i)
          } else this.getMenuAccessoryResource()
        }
      })
    },
    getMenuAccessoryResource (index) {
      if (index) this.amount.others = index
      const url = this.base + this.id + '/menu/accessoryResource?page=' + this.amount.others + '&size=' + this.count
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          this.getMenuInfo()
          let resList = []
          resList.push(response.data.resource_list)
          resList.forEach((category) => {
            this.$set(category, 'is_enable', this.created)
            this.$set(category, 'is_visible', this.created)
            this.$set(category, 'is_remove', this.created)
            category.product_list.forEach((product) => {
              this.$set(product, 'is_enable', this.created)
              this.$set(product, 'is_visible', this.created)
              this.$set(product, 'is_remove', this.created)
            })
            this.accessory.push(category)
          })
        }
      })
    },
    getMenuInfo () {
      let url = this.base + this.id + '/menu/' + this.$route.params.menu_id
      if (this.getRoleType === 10) {
        if (this.$route.params.menu_id) url = this.base + this.id + '/menu/' + this.$route.params.menu_id
      }
      if (this.$route.query.copy_menu_id) url = this.base + this.id + '/menu/' + this.$route.query.copy_menu_id
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          // 因為 product_id會不同 無法辨識是否選擇過
          if (response.data.menu.src_join_param) {
            this.category.forEach((category) => {
              this.$set(category, 'is_enable', true)
              this.$set(category, 'is_visible', true)
              this.$set(category, 'is_remove', true)
              category.package_list.forEach((pack) => {
                this.$set(pack, 'is_enable', true)
                this.$set(pack, 'is_visible', true)
                this.$set(pack, 'is_remove', true)
              })
              category.product_list.forEach((product) => {
                this.$set(product, 'is_enable', true)
                this.$set(product, 'is_visible', true)
                this.$set(product, 'is_remove', true)
                product.combine_list.forEach((combine) => {
                  this.$set(combine, 'is_enable', true)
                  this.$set(combine, 'is_visible', true)
                  this.$set(combine, 'is_remove', true)
                })
              })
            })
            this.accessory.forEach((category) => {
              category.product_list.forEach((product) => {
                this.$set(product, 'is_enable', true)
                this.$set(product, 'is_visible', true)
                this.$set(product, 'is_remove', true)
              })
            })
            let menu = response.data.menu.src_join_param
            this.category.find((category) => {
              for (let c = 0; c < menu.category.length; c++) {
                let cKey = menu.category[c]
                if (category.category_id === parseInt(cKey, 10)) {
                  category.is_enable = false
                  category.is_visible = false
                  category.is_remove = false
                }
              }
              category.package_list.find((pack) => {
                for (let pa = 0; pa < menu.package.length; pa++) {
                  let paKey = menu.package[pa]
                  if (pack.package_id === parseInt(paKey, 10)) {
                    pack.is_enable = false
                    pack.is_visible = false
                    pack.is_remove = false
                  }
                }
              })
              category.product_list.find((prod) => {
                for (let p = 0; p < menu.product.length; p++) {
                  let pKey = menu.product[p]
                  if (prod.product_id === parseInt(pKey, 10)) {
                    prod.is_enable = false
                    prod.is_visible = false
                    prod.is_remove = false
                  }
                }
                prod.combine_list.find((combine) => {
                  for (let co = 0; co < menu.combination.length; co++) {
                    let coKey = menu.combination[co]
                    if (combine.combine_id === parseInt(coKey, 10)) {
                      combine.is_enable = false
                      combine.is_visible = false
                      combine.is_remove = false
                    }
                  }
                })
              })
            })
            this.accessory.find((category) => {
              category.product_list.find((prod) => {
                for (let ap = 0; ap < menu.accessory.length; ap++) {
                  let apKey = menu.accessory[ap]
                  if (prod.product_id === parseInt(apKey, 10)) {
                    prod.is_enable = false
                    prod.is_visible = false
                    prod.is_remove = false
                  }
                }
              })
            })
          }
        }
      })
    },
    joinMenu () {
      this.all = {
        category: [],
        product: [],
        combination: [],
        package: [],
        accessory: []
      }
      let caList = this.category
      for (let c = 0; c < caList.length; c++) {
        if (!caList[c].is_remove) this.all.category.push(caList[c].category_id + '/' + this.booToNum(caList[c].is_remove) + '/' + this.booToNum(caList[c].is_remove))
        // product
        let pList = caList[c].product_list
        for (let p = 0; p < pList.length; p++) {
          if (!pList[p].is_remove) this.all.product.push(pList[p].product_id + '/' + this.booToNum(pList[p].is_remove) + '/' + this.booToNum(pList[p].is_remove))
          if (pList[p].combine_list) {
            let comList = pList[p].combine_list
            for (let com = 0; com < comList.length; com++) {
              if (!comList[com].is_remove) this.all.combination.push(comList[com].combine_id + '/' + this.booToNum(comList[com].is_remove) + '/' + this.booToNum(comList[com].is_remove))
            }
          }
        }
        // package
        let paList = caList[c].package_list
        for (let pa = 0; pa < paList.length; pa++) {
          if (!paList[pa].is_remove) this.all.package.push(paList[pa].package_id + '/' + this.booToNum(paList[pa].is_remove) + '/' + this.booToNum(paList[pa].is_remove))
        }
      }
      // accessory
      let aList = this.accessory
      for (let a = 0; a < aList.length; a++) {
        let apList = aList[a].product_list
        for (let ap = 0; ap < apList.length; ap++) {
          if (!apList[ap].is_remove) this.all.accessory.push(apList[ap].product_id + '/' + this.booToNum(apList[ap].is_remove) + '/' + this.booToNum(apList[ap].is_remove))
        }
      }
      // console.log(this.all)
      const url = this.base + this.id + '/menu/' + this.$route.params.menu_id + '/join'
      this.getDataH('put', url, this.all, (response) => {
        if (response.data.status === 200) {
          let name = ''
          let params = {
            brand_id: this.$route.params.brand_id,
            menu_id: this.$route.params.menu_id,
            store_id: ''
          }

          if (this.isStore && this.getRoleType !== 10) {
            name = 'StoreMenuInfo'
            params.store_id = this.$route.params.store_id
          } else {
            name = 'menuInfo'
          }

          this.$router.push({ name, params })
        }
      })
    },
    booToNum (boo) {
      if (boo === true) {
        return 0
      } else {
        return 1
      }
    },
    choseAllOption (adjust) {
      this.adjust.filter((elem) => {
        if (elem.adjust_id === adjust.adjust_id) {
          elem.is_enable = true
          elem.is_visible = true
          elem.is_remove = true
          if (elem.option_list.length) {
            for (let i = 0; i < elem.option_list.length; i++) {
              let option = elem.option_list[i]
              option['is_enable'] = true
              option['is_visible'] = true
              option['is_remove'] = true
            }
          }
        }
      })
    },
    cancelAllOption (adjust) {
      this.adjust.filter((elem) => {
        if (elem.adjust_id === adjust.adjust_id) {
          elem.is_enable = false
          elem.is_visible = false
          elem.is_remove = false
          if (elem.option_list.length) {
            for (let i = 0; i < elem.option_list.length; i++) {
              let option = elem.option_list[i]
              option['is_enable'] = false
              option['is_visible'] = false
              option['is_remove'] = false
            }
          }
        }
      })
    },
    changeAdjustAdd (adjust) {
      this.adjust.filter((elem) => {
        if (elem.adjust_id === adjust.adjust_id) {
          if (elem.option_list.length) {
            for (let i = 0; i < elem.option_list.length; i++) {
              let option = elem.option_list[i]
              option['is_remove'] = elem.is_remove
            }
          }
        }
      })
    },
    changeCategoryAdd (category, isChecked = null) {
      if (isChecked !== null) {
        category.is_remove = isChecked
      }
      category.is_remove = !category.is_remove
      category.product_list.forEach((product) => {
        product['is_remove'] = category.is_remove
        if (product.combine_list) {
          product.combine_list.forEach((combine) => {
            combine['is_remove'] = category.is_remove
          })
        }
      })
      if (category.package_list) {
        category.package_list.forEach((pa) => {
          pa['is_remove'] = category.is_remove
        })
      }
    },
    changeProductAdd (category, product) {
      product.is_remove = !product.is_remove
      if (product.combine_list) {
        for (let j = 0; j < product.combine_list.length; j++) {
          let combine = product.combine_list[j]
          combine['is_remove'] = product.is_remove
        }
      }

      if (!product.is_remove) {
        category.is_remove = product.is_remove
      }
    },
    changeCombineAdd (category, product, combination) {
      combination.is_remove = !combination.is_remove
      if (!combination.is_remove) {
        product.is_remove = combination.is_remove
        category.is_remove = combination.is_remove
      }
    }
  },
  created () {
    this.init()
  },
  mounted () {
    this.showMenu()
  },
  updated () {
    this.showMenu()
  },
  computed: {
    ...mapGetters(['getRoleType']),
    getDataH () {
      return this.$parent.getDataH
    },
    checkInput () {
      return this.$parent.checkInput
    }
  }
}
</script>

<style lang="sass" scoped>
  $default-color: #e1456d
  $light-gray: rgb(238, 238, 238)
  .label-text-60-p
    font-size: 60% !important
  .m-t-10
    margin-top: 10px !important
  .m-b-5
    margin-bottom: 5px !important
  .m-r-5
    margin-right: 5px !important
  .m-r-20
    margin-right: 20px !important
  .m-r-15
    margin-right: 15px !important
  .p-x-15
    padding-left: 15px
    padding-right: 15px
  .block-checkbox
    right: 0px
    position: absolute
    top: 3px
  .card-title .block-checkbox
    top: 8px
  .checkbox-visible, .checkbox-enable
    margin-left: 20px
  .text-dark-gray
    color: #333 !important
  .text-light-gray
    color: #666 !important
  .text-13
    font-size: 13px !important
  .btn-option-show
    background: #ffffff
    border: 1px solid $default-color
    min-width: 100px
    font-size: 15px
    border-radius: 5px
    cursor: auto
  input[type="checkbox"]
    margin-left: 0
    padding: 0
  input[type=checkbox].css-checkbox
    position: absolute
    overflow: hidden
    clip: rect(0 0 0 0)
    height: 1px
    width: 1px
    margin: -1px
    padding: 0px
    border: 0
  input[type=checkbox].css-checkbox+label.css-label
    padding-left: 22px
    height: 16px
    width: 16px
    display: inline-block
    line-height: 15px
    background-repeat: no-repeat
    background-position: 0 0
    font-size: 13px
    vertical-align: middle
    cursor: pointer
    opacity: 1
  input[type=checkbox].css-checkbox+label.css-label:hover
    opacity: 0.5
  input[type=checkbox].css-checkbox:checked+label.css-label
    background-position: 0 -17px
  .css-label:not(.css-label-add)
    background-image: url(/static/img/checkbox.png)
    background-size: 16px
  .css-label.css-label-add
    background-image: url(/static/img/checkbox-not.png)
    background-size: 16px
  input[type=checkbox].css-checkbox+label.css-label.disabled:hover
    opacity: 1
  .combine-gray
    color: #C6C6C6
  .card
    border: 1px solid #eee;
    border-radius: 5px;
    box-shadow: 0 1px 3px rgba(0,0,0,.12), 0 1px 2px rgba(0,0,0,.24);
    background: #fff;
  .card-title
    color: #e1456d;
    line-height: 40px;
    font-size: 20px;
    font-weight: 400;
    margin-bottom: 15px;
    padding-top: 5px;
  .card-product
    width: 100%;
    padding-top: 10px;
    padding-bottom: 10px;
    border-bottom: 1px solid #eee;
</style>



// WEBPACK FOOTER //
// CrJoinMenuTemp.vue?ca91f3a0